import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Authorization } from '../../model/authorization';
import { AuthRoles } from '../../model/AuthRoles';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthCompareComponent } from '../auth-compare/auth-compare.component';
import { AuthorizationService } from '../../service/authorizationService';
import { BasicAuthorization } from '../../model/basic-authorization';
import { UserService } from '../../service/user.service';
import { Essentials, MsgType } from '../../util/essentials';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import type { RoleSubType } from '../../model/roleSubType.model';
import { Blockade } from '../../model/blockade';
import { AuthService } from '../../service/auth.service';
import { User } from '../../model/user';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent implements OnInit {

  @Input() authorization: BasicAuthorization;
  @Input() roleSubTypes: RoleSubType[] = [];
  @Input() enableCustomRoleSubType: boolean = false;
  @Output() cardClicked: EventEmitter<any> = new EventEmitter();
  @Output() onReleaseClicked: EventEmitter<any> = new EventEmitter();

  public insertStampInPhoto: boolean;
  viewSensitiveUserData: boolean = false;


  thumbnail: any = '';
  constructor(
    private essentials: Essentials,
    private userService: UserService,
    private modalservice: BsModalService,
    private authorizationService: AuthorizationService,
    public datepipe: DatePipe,
    private translate: TranslateService
    ) {
      this.thumbnail = essentials.getDefaultAvatar();
    }

  ngOnInit(): void {
    let updatedAt = Date.parse(this.authorization.userUpdatedPhotoB64At);
    this.userService.getThumbnail(this.authorization.userId, updatedAt.valueOf())
    .subscribe(data => {
      this.thumbnail = data.thumbnail;
    });

    this.getDays();

  }

  getRoleSubType(roleSubTypeId: number) {
    let roleSubType = this.roleSubTypes.find(r => r.id == roleSubTypeId)?.subType;
    return roleSubType != undefined ? roleSubType : '';
  }

  getDays(){
    this.insertStampInPhoto = false
    const startAt = new Date(this.authorization.userUpdatedPhotoB64At); //data de quando a foto foi atualizada
    const endAt = new Date(Date.now()); // data atual
    const duration = endAt.getTime() - startAt.getTime(); // tempo em milisegundos
    const days = Math.floor(duration / (1000 * 60 * 60 * 24));

    if(days > 180) this.insertStampInPhoto = true;
  }

  isExpired() {
    let endDate = new Date(this.authorization.validPeriodEndsAt);
    let currentDate = new Date(Date.now());
    const result = endDate <= currentDate;
    return result;
  }

  onCardClick(){
    //if (this.authorization == undefined || this.isExpired())
    if (this.authorization == undefined)
      return;

    this.authorizationService.getById(this.authorization.id, this.viewSensitiveUserData).subscribe((fullAuth: Authorization) => {
      fullAuth.performedByUserName = this.authorization.authorizer;

      this.cardClicked.emit(fullAuth);
    }, ((error) => {
      console.log(error.message)
    }));
  }

  translateRole(role: string) {

    switch(role){
      case AuthRoles.resident : return this.translate.instant("ROLES.RESIDENT");
      case AuthRoles.employee : return this.translate.instant("ROLES.EMPLOYEE");
      case AuthRoles.visitor_residence : return this.translate.instant("ROLES.VISITOR_RESIDENCE");
      case AuthRoles.visitor_company : return this.translate.instant("ROLES.VISITOR_COMPANY");
      case AuthRoles.service_provider : return this.translate.instant("ROLES.SERVICE_PROVIDER");
      default: return "Not found role";
    }

    //return AuthRoles_PTBR.hasOwnProperty(role) ? AuthRoles_PTBR[role] : role;
  }

  getFormatedLastAccessIn() {
    if (!this.isNullOrEmpty(this.authorization.lastAccessIn)) {
      return this.datepipe.transform(this.authorization.lastAccessIn, 'dd/MM/yy HH:mm');
    }
    return '--'
  }

  getFormatedLastAccessOut() {
    if (!this.isNullOrEmpty(this.authorization.lastAccessIn)
    && !this.isNullOrEmpty(this.authorization.lastAccessOut)) {

      let lastAccessIn = new Date(this.authorization.lastAccessIn);
      let lastAccessOut = new Date(this.authorization.lastAccessOut);
      if (lastAccessIn < lastAccessOut) {
        return this.datepipe.transform(lastAccessOut, 'dd/MM/yy HH:mm');
      }
    }
    return '--'
  }

  getFormatedValidPeriodStartsAt(){
    if (!this.isNullOrEmpty(this.authorization.validPeriodStartsAt)){
      let validPeriodStartsAt = new Date(this.authorization.validPeriodStartsAt)
      return this.datepipe.transform(validPeriodStartsAt, 'dd/MM/yy HH:mm');
    }
  }

  getFormatedValidPeriodEndsAt(){
    if (!this.isNullOrEmpty(this.authorization.validPeriodEndsAt)){
      let validPeriodEndsAt = new Date(this.authorization.validPeriodEndsAt)
      return this.datepipe.transform(validPeriodEndsAt, 'dd/MM/yy HH:mm');
    }
  }

  isNullOrEmpty(value: string) {
    return value == undefined || value == null || value.trim() == '';
  }

  releaseFromLobby() {
    if (this.authorization == undefined || this.isExpired())
      return;

    const authId = AuthService.getUserIdFromClaims();
    this.authorizationService.getByUser(authId).subscribe((auth: any) => {
      // Verifica se o usuário que está tentando liberar outro usuário ou dele mesmo está bloqueado
      if(auth.items.length > 0 && Blockade.isActive(auth.items[0].ownerUser.currentBlockade != null ? auth.items[0].ownerUser.currentBlockade : new Blockade())) {
        this.essentials.showMessage('Acesso negado', MsgType.Warning, 'Você não pode liberar usuários enquanto estiver bloqueado.');

      }else{
        this.authorizationService.getById(this.authorization.id, true).subscribe((fullAuth: Authorization) => {
          this.onReleaseClicked.emit(fullAuth);
        }, ((error) => {
          console.log(error.message)
        }));
      }
    }, ((error) => {
      console.log(error.message)
    }))
  }

  footerClicked() {
    if (this.authorization == undefined || this.isExpired())
      return;

    if (this.conflictUserId > 0) {
      this.authorizationService.getById(this.authorization.id, true).subscribe((currentAuth: Authorization) => {

        this.authorizationService.getByUser(this.conflictUserId).subscribe(resp => {
          let otherUserAuthFound;
          resp.items.forEach((otherUserAuth: Authorization) => {
            if (otherUserAuth != undefined) {
              otherUserAuthFound = otherUserAuth;
            }
          });

          let modalRef = this.modalservice.show(AuthCompareComponent, Object.assign({}, { class: 'gray modal-md modal-dialog-centered' }));
          modalRef.content.modalRef = modalRef;
          modalRef.content.auth1 = currentAuth;
          modalRef.content.auth2 = otherUserAuthFound;
        });

      }, ((error) => {
        console.log(error.message)
      }));
    }
    else if (this.showReleaseBtn) {
      this.releaseFromLobby();
    }
  }

  get conflictUserId() {
    let conflictUserId = 0;
    try {
      let errorMessage: string = this.authorization.userUpdateStatusErrorMessage;
      let refInitPos = errorMessage.indexOf('[');
      let refEndPos = errorMessage.indexOf(']');
      if (refInitPos > 0 && refEndPos > 0) {
        let ref = errorMessage.substring(refInitPos + 1, refEndPos).split('/')[0];
        conflictUserId = Number.parseInt(ref.substr(2, ref.length - 2));
      }
    }
    catch {}
    return conflictUserId;
  }

  get getAccent() {
    if (this.authorization != undefined && !this.isExpired()) {
      const status_num: number = +this.authorization.userUpdateStatus;
      if (status_num == 0)
      return 'warning';
      if (status_num == 1)
      return 'success';
      if (status_num == 2)
      return 'danger';
    }

    return 'basic';
  }

  get showReleaseBtn() {
    return this.authorization.waitOnLobby || this.authorization.currentBlockade != null;
  }

}

